// Testimonials.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Star } from "lucide-react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "./Testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Louie Lito Tan",
      feedback:
        "We booked 4 days of private tours. Great service. Did not disappoint. Tour guide Vince and his crew made us feel safe the entire trip. Went the extra mile to make sure we fully enjoy the trips each day. Would definitely book this company again and I would specifically request for him and his crew.",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image1.png",
    },
    {
      id: 2,
      name: "McLeen Abaca",
      feedback:
        "Our 2-days Island Tour was superb! Thank you po kay Kuya Danny for assisting us! Very hands on sa guest especially sa mga non-swimmers, di ka papabayaan talaga! Kay Kuya Austin na magaling din kumuha ng mga pics. Thank you thank you!! 🤗",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image2.png",
    },
    {
      id: 3,
      name: "Bambi Cook",
      feedback:
        "🙏Amazing experience!! We did the Super Ultimate and Ultimate Explorer Tours...WOW. A big thank you to Lea and Tour Guides Richard, Ronel & Augustine. Everyone should visit Coron....it's such a special and unforgettable place!!🥰",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image3.png",
    },
    {
      id: 4,
      name: "Isabella Dang",
      feedback:
        "I did 2 tours for 2 days here and very happy I did. Tour B and the Ultimate tour go through my favorite free diving spots like Coral Garden, Skeleton ship wreck, Baracuda lake, and Twin lagoon (where I spotted a school of Baracuda fish and yellow jellyfish). The lunch for both day were delicious. The team is very attentive, friendly and kind. Special thanks to Agustin for making my mermaid dreams come true. His photography skills are truly the best! I am extremely grateful for these beautiful footages. Highly recommend to everyone who wants to see the best of Coron and get the best digital memory souvenirs❤️",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image4.png",
    },
    {
      id: 5,
      name: "Jaja Lopez Estrella",
      feedback:
        "Thank you very much Twin Travel Coron for the amazing Super Ultimate Tour that I joined in last Sunday, June 9. All the staff (admin, boatmen, tour guides) were very kind and approachable and would not hesitate to help you if you need anything. Also, they made a little tweak on the itinerary so we can avoid the crowd during the tour. We get to enjoy each places with lesser to zero people which is awesome! Special shout out to Sir Richard (head tour guide) and Sir Ronnel (Assistant Tour Guide, I hope I get your name correctly) who made our tour unforgettable. Thank you for the great photos too! I’ll definitely book your agency again when I get back here in Coron. Maraming salamat po!!! 👏🏼👏🏼👏🏼",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image5.png",
    },
    {
      id: 6,
      name: "Anne Moisson",
      feedback:
        "Don't hesitate, Twin Travel and Tour is a great team. We did the super ultimate tour as a private tour for two. We wanted to leave early before the rush of other boats and they were right on time. Our guide Jim was perfect. Friendly, he Fiat us around the different sites so that we were almost alone. The meal was absolutely correct and copious. The sites are magnificent and well worth the trip... Having tried two days before with another agency unable to organize properly, I can tell you that Twin Travel and Tour was perfect. And the icing on the cake: cheaper than the others! Don't hesitate!",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image6.png",
    },
    {
      id: 7,
      name: "Raine Dakila-Alfar ",
      feedback:
        "Thank you Twin Travel for our Coron travel experience! Shout out to Kuya Richard for giving us a very accommodating service specially for assisting my mom! In our 6 days tour, he’s the only guide who helped my mom to go and see the beauty of Coron. Due to her ear condition, she is not allowed to go to the water. But because of Kuya Richard, it is possible for her to see the corals, the fish, the rock formations, even letting her stay in the middle of the lagoon. But of course with careful guidance! I also recommend Kuya Austin for our best captured photos and videos.We booked Twin Travel Agency for two private tours. And it is all worth it! bFood ✅ Service ✅ Pick-up/Drop off ✅ Tour guide ✅ Boat",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image7.png",
    },
    {
      id: 8,
      name: "Liezl del Rosario",
      feedback:
        "It was recommended to me by my brother’s wife since they are also the one who accommodate them nung nag-coron sila, and they never disappoint!! Sobrang accommodating mula nung lumapag kami sa coron hanggang sa mga nagstart na yung nga tours namin. Kababait pa ng mga tour guides. Kahit ako na di marunong lumangoy eh sobrang naenjoy talaga Thank you very much! ",
      rating: 5,
      img: "https://twintravelcoron.com/testimonials/image8.png",
    },
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }).map((_, index) => (
      <Star
        key={index}
        size={20}
        color={index < rating ? "#d4af37" : "#e0e0e0"}
        fill={index < rating ? "#d4af37" : "none"}
      />
    ));
  };

  return (
    <div className="testimonialsMainContainer">
      <h2 className="subTitle">Our Clients' Words</h2>
      <section className="testimonials-container">
        <div className="testimonials-section">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            loop={true}
            style={{
              overflow: "hidden",
              width: "100%",
              padding: "10px 5px",
            }}
          >
            {testimonials.map((testimonial) => (
              <SwiperSlide
                key={testimonial.id}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  opacity: 1,
                  transition: "opacity 0.5s ease",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    backdropFilter: "blur(12px)",
                    borderRadius: "20px",
                    padding: "10px",
                    textAlign: "center",
                    transition: "transform 0.4s, box-shadow 0.4s",
                    border: "1px solid rgba(255, 255, 255, 0.8)",
                    boxShadow: "0 5px 5px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                    width: "96%",
                  }}
                >
                  <div
                    style={{
                      width: "90px",
                      height: "90px",
                      margin: "0 auto 15px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "4px solid #d4af37",
                      padding: "3px",
                      boxShadow: "0 0 10px rgba(212, 175, 55, 0.5)",
                    }}
                  >
                    <img
                      src={testimonial.img}
                      alt={testimonial.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                      loading="lazy"
                    />
                  </div>
                  <p className="responsive-feedback">
                    "{testimonial.feedback}"
                  </p>
                  <div
                    style={{
                      margin: "10px 0",
                      display: "flex",
                      justifyContent: "center",
                      gap: "5px",
                    }}
                  >
                    {renderStars(testimonial.rating)}
                  </div>
                  <h3
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "bold",
                      color: "#333",
                      fontFamily: "Playfair Display, serif",
                    }}
                  >
                    {testimonial.name}
                  </h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="testimonial-video">
          <video autoPlay muted loop controls>
            <source
              src="https://videos.pexels.com/video-files/8379838/8379838-hd_1920_1080_30fps.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
